import { Check, Copy } from "lucide-react";
import { useEffect, useState } from "react";
import { copyText } from "../lib/clipboard";
import { triggerHaptic } from "../lib/telegram";

interface CopyButtonProps {
  text: string;
  label?: string;
  className?: string;
}

export function CopyButton({ text, label = "Скопировать", className = "" }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), 1800);
    return () => window.clearTimeout(timer);
  }, [copied]);

  const handleCopy = async () => {
    const successful = await copyText(text);
    if (successful) {
      setCopied(true);
      triggerHaptic("copy");
    }
  };

  return (
    <>
      <button type="button" className={`button button--secondary ${className}`} onClick={handleCopy} aria-label={label}>
        {copied ? <Check size={17} aria-hidden="true" /> : <Copy size={17} aria-hidden="true" />}
        {copied ? "Скопировано" : label}
      </button>
      {copied && <div className="toast" role="status">Скопировано.</div>}
    </>
  );
}
